export default __webpack_public_path__ + "static/media/angle-up.9e71ba16.svg";